<template><canvas id="flight-time"></canvas></template>

<script>
import Chart from "chart.js/auto";
export default {
	mounted() {
		const planetChartData = {
			type: "bar",
			data: {
				labels: [
					"Mercury",
					"Venus",
					"Earth",
					"Mars",
					"Jupiter",
					"Saturn",
					"Uranus",
					"Neptune",
				],
				datasets: [
					{
						label: "Flighttime",
						type: "bar",
						data: [
							0.166, 2.081, 3.003, 0.323, 954.792, 285.886, 43.662, 51.514,
						],
						backgroundColor: "rgba(71, 183,132,.5)",
						borderColor: "#47b784",
						borderWidth: 3,
					},
				],
			},
		};
		const flightchart = document.getElementById("flight-time");
		new Chart(flightchart, planetChartData);
	},
};
</script>
